import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ServerStatusService } from '@nida-web/api/rest/authentication';
import { Endpoint } from '@nida-web/api/rest/authentication';

@Injectable({
  providedIn: 'root',
})
export class AvailableEndpointsStoreService {
  private endpointsCache: Endpoint[] | null = null;

  constructor(private serverStatusService: ServerStatusService, @Inject('SERVER_BASE_HREF') private baseHref: string) {}

  getEndpoints(forceReload = false): Observable<Endpoint[]> {
    // Wenn der Cache vorhanden ist und kein Neuladen erzwungen wird, gib den Cache zurück
    if (this.endpointsCache && !forceReload) {
      return of(this.endpointsCache);
    }

    return this.serverStatusService.getAvailableEndpoints().pipe(
      map((endpoints) => (endpoints.data ? endpoints.data : [])),
      map((endpoints) => endpoints.map((endpoint) => AvailableEndpointsStoreService.removeBaseHref(endpoint, this.baseHref))),
      tap((endpoints) => (this.endpointsCache = endpoints))
    );
  }

  public static removeBaseHref(endpoint: Endpoint, baseHref: string): Endpoint {
    let newPath = endpoint.path;
    if (baseHref && endpoint.path?.startsWith(baseHref)) {
      newPath = endpoint.path.slice(baseHref.length);
    }
    return { ...endpoint, path: newPath };
  }

  reloadEndpoints(): void {
    this.getEndpoints(true).subscribe();
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public static endpointsContained(availableEndpoints: Endpoint[], requiredEndpoints: Endpoint[]): boolean {
    // matchingEndpoint.path = matchingEndpoint.path.replace(environment.baseHref, '');
    return requiredEndpoints.every((requiredEndpoint) => {
      const matchingEndpoint = availableEndpoints.find((endpoint) => endpoint.path === requiredEndpoint.path);

      if (!matchingEndpoint) return false;

      // Überprüfe, ob alle erforderlichen Methoden vorhanden sind
      return requiredEndpoint.methods?.every((method) => matchingEndpoint.methods?.includes(method)) || false;
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public static pathsContained(availableEndpoints: Endpoint[], requiredPaths: string[]): boolean {
    return requiredPaths.every((requiredPath) => availableEndpoints.some((endpoint) => endpoint.path === requiredPath));
  }
}
